import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[400px] md:h-[500px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20news%20background%20with%20warm%20crimson%20and%20amber%20glow%2C%20bold%20graphic%20composition%2C%20Chinese%20entertainment%20media%20aesthetic%2C%20high%20contrast%2C%20editorial%20design%2C%20dark%20moody%20atmosphere%2C%20clean%20simple%20composition%2C%20no%20text&width=1600&height=500&seq=cta-home-bg&orientation=landscape"
        alt="加入吃瓜"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="max-w-lg">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
              你有猛料？
              <br />
              我们帮你曝光
            </h2>
            <p className="text-sm md:text-base text-background-200 leading-relaxed mb-8">
              严格保护爆料人隐私，匿名投稿，真实可靠。你的爆料可能就是下一个头条！
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-3 whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full font-label text-sm transition-colors cursor-pointer"
            >
              立即爆料
              <span className="w-7 h-7 rounded-full bg-background-950/30 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}